import React from "react";
import Skeleton from "react-loading-skeleton";
import ProfilePageSkeleton from "../../profiles/ProfilePageSkeleton";
import SectionSkeleton from "../../profiles/SectionSkeleton";

// Media Outlet loading state on the shared <ProfilePageSkeleton> chassis: an entity-header
// placeholder (square logo, no cover band) + section-card placeholders. Mirrors the loaded layout.
function MediaOutletHeaderSkeleton() {
  return (
    <div className="card p-4 animated fadeIn faster">
      <div className="row">
        <div className="col-12 col-sm-auto d-flex justify-content-center mb-3 mb-sm-0">
          <Skeleton height={120} width={120} />
        </div>
        <div className="col">
          <Skeleton height={28} width="40%" />
          <Skeleton height={16} width="25%" className="mt-2" />
        </div>
      </div>
    </div>
  );
}

function MediaOutletSkeleton() {
  return (
    <ProfilePageSkeleton header={<MediaOutletHeaderSkeleton />}>
      <SectionSkeleton lines={4} />
      <SectionSkeleton lines={2} />
    </ProfilePageSkeleton>
  );
}

export default MediaOutletSkeleton;
